/**
 * F-135: the file extension a stored asset's recorded content type implies.
 * Shared by the server's download header (`Content-Disposition` for an asset
 * nobody named) and the client's save-as name (an image uploaded before file
 * names were recorded, or re-encoded on the way up), so a download is called
 * the same thing whichever side named it.
 */
const ASSET_EXTENSIONS = {
    "image/png": "png",
    "image/jpeg": "jpg",
    "image/gif": "gif",
    "image/webp": "webp",
    "audio/mpeg": "mp3",
    "audio/wav": "wav",
    "audio/mp4": "m4a",
    "audio/aac": "aac",
    "audio/ogg": "ogg",
    "audio/flac": "flac",
    "video/mp4": "mp4",
    "video/quicktime": "mov",
    "video/3gpp": "3gp",
    "video/webm": "webm",
    "video/x-matroska": "mkv",
    "video/x-msvideo": "avi",
    "video/mpeg": "mpg",
    "video/mp2t": "ts",
    "video/x-flv": "flv",
    "application/pdf": "pdf",
};
/**
 * `bin` for anything unmapped — honest, and every OS opens the picker for
 * it. A `type; charset=…` parameter is ignored.
 */
export function assetExtensionFor(contentType) {
    const bare = contentType.split(";")[0]?.trim().toLowerCase() ?? "";
    return ASSET_EXTENSIONS[bare] ?? "bin";
}
/**
 * `name` with its extension replaced by the one `contentType` implies, when
 * they disagree — the client re-encodes large PNG/JPEGs as WebP before
 * upload (`optimizeForUpload`), so "photo.jpg" may hold WebP bytes and must
 * be saved as "photo.webp". A type this table cannot name leaves the name
 * alone: the user's extension is better than "bin".
 */
export function withExtensionFor(name, contentType) {
    const ext = assetExtensionFor(contentType);
    if (ext === "bin")
        return name;
    const dot = name.lastIndexOf(".");
    const stem = dot > 0 ? name.slice(0, dot) : name;
    const current = dot > 0 ? name.slice(dot + 1).toLowerCase() : "";
    // "jpeg" and "jpg" are the same thing; keep what the user wrote.
    if (current === ext || (ext === "jpg" && current === "jpeg"))
        return name;
    return `${stem}.${ext}`;
}
//# sourceMappingURL=asset-names.js.map